
import { defineComponent, toRefs } from 'vue';

import { Step, useStepperNavigation } from '@/components/wizard';
import Button from '@/components/Button.vue';
import { TestimonialPopupList } from '@/components/testimonial';

export default defineComponent({
  name: 'Intro',
  props: {
    step: Number,
  },
  components: {
    TestimonialPopupList,
    Button,
    Step,
  },
  setup(props) {
    const { step } = toRefs(props);
    const { isVisible, currentStep, nextStep } = useStepperNavigation(step);

    return {
      isVisible,
      currentStep,
      nextStep,
    };
  },
});
